<script setup lang="ts"></script>

<template>
  <div class="filter-bar">
    <slot></slot>
  </div>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";
  .filter-bar {
    @apply mb-4 flex items-end flex-wrap justify-end gap-4 max-sm:flex-col;
  }
</style>

<style>
  @reference "@/assets/styles/main.css";
  .filter-bar > div {
    @apply max-sm:w-full;
  }
  .filter-bar:has(+ .card) {
    margin-bottom: 48px;
  }
</style>
